import React from 'react';
import Alert from '@amzn/awsui-components-console/alert';
import { NO_PII_NOTICE_HEADER_ID, NO_PII_NOTICE_BODY_ID } from './constants';
import { useTranslation } from 'src/i18n/shim/useTranslation';

/**
 * Purpose-limitation disclaimer required by the Workplace Trust privacy review
 * (HRPRP-61509 — https://issues.amazon.com/issues/HRPRP-61509). LangHub sends
 * authored content to human translators, so the review made this notice a
 * condition of launch: it must appear in every modal where free-form content is
 * authored or submitted, at the point of authoring rather than once per session.
 *
 * Deliberately not dismissible — a user who dismissed it would author the rest
 * of the group without ever seeing it, which is exactly the case the review
 * asked to cover.
 */
const NoPiiNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Alert type="warning" header={t(NO_PII_NOTICE_HEADER_ID)}>
      {t(NO_PII_NOTICE_BODY_ID)}
    </Alert>
  );
};

export default NoPiiNotice;
